import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';

// This query fetches guard results nested to 4 levels deep, which is the limit
// enforced by the backend for guards (see assertPipelineGuardStructureIsAllowed).
const GET_PROJECT_POTENTIAL_PIPELINE_TRANSITIONS = graphql(`
  query GetProjectPotentialPipelineTransitions($id: ID!) {
    projectById(id: $id) {
      id
      publicId
      potentialPipelineTransitions {
        targetStage {
          id
          publicId
        }
        isAllowed
        guardResult {
          ...GuardResultFields
          children {
            ...GuardResultFields
            children {
              ...GuardResultFields
              children {
                ...GuardResultFields
              }
            }
          }
        }
      }
    }
  }

  fragment GuardResultFields on PipelineGuardResult {
    isSatisfied
    guard {
      __typename
      ... on PipelineGuardSimpleCondition {
        type
      }
      ... on IPipelineGuard {
        validityResult {
          isValid
          reasons
        }
      }
      ... on PipelineGuardProjectHasTagCondition {
        tag {
          name
        }
      }
      ... on PipelineGuardCustomFieldCondition {
        fieldPath
        predicate {
          __typename
          ... on EqualsCustomFieldConditionPredicate {
            comparisonValue
            comparisonEntity {
              ... on User {
                publicId
                fullName
              }
            }
          }
          ... on NotEqualsCustomFieldConditionPredicate {
            comparisonValue
            comparisonEntity {
              ... on User {
                publicId
                fullName
              }
            }
          }
        }
        field {
          id
          label
          type
        }
      }
    }
  }
`);

const useGetProjectPotentialPipelineTransitions = (projectId?: string) => {
  const { data, isLoading, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.potentialPipelineTransitions(projectId!),
    queryFn: () => {
      return gqlClient.request(GET_PROJECT_POTENTIAL_PIPELINE_TRANSITIONS, {
        id: projectId!,
      });
    },
  });

  return {
    potentialPipelineTransitions:
      data?.projectById.potentialPipelineTransitions,
    isLoading,
    ...rest,
  };
};

export default useGetProjectPotentialPipelineTransitions;
